import { useEffect, useState } from "react";
import { MountainSnow, Phone } from "lucide-react";

const LINKS = [
  { href: "#services", label: "Services", testid: "nav-services-link" },
  { href: "#about", label: "About", testid: "nav-about-link" },
  { href: "#coverage", label: "Coverage", testid: "nav-suburbs-link" },
  { href: "#quote", label: "Free Quote", testid: "nav-quote-link" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? "border-white/10 bg-[#0B0F17]/80 backdrop-blur-xl" : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <a href="#top" data-testid="nav-logo" className="group flex items-center gap-3">
          <span className="grid h-9 w-9 place-items-center bg-orange-500 text-[#0B0F17] transition-colors duration-300 group-hover:bg-orange-400">
            <MountainSnow className="h-5 w-5" strokeWidth={2.4} />
          </span>
          <span className="leading-tight">
            <span className="block font-heading text-sm font-extrabold uppercase tracking-[0.18em] text-slate-100">
              Total Roof Care
            </span>
            <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-orange-400">
              Taranaki · NZ
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="font-mono text-xs uppercase tracking-[0.2em] text-slate-300 transition-colors duration-200 hover:text-orange-400"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="tel:0225477534"
          data-testid="nav-phone-button"
          className="flex items-center gap-2 border border-orange-500/50 px-3 py-2 font-mono text-xs font-semibold uppercase tracking-[0.15em] text-orange-400 transition-colors duration-300 hover:bg-orange-500 hover:text-[#0B0F17] sm:px-4"
        >
          <Phone className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">022 547 7534</span>
          <span className="sm:hidden">Call</span>
        </a>
      </div>
    </header>
  );
}
